import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SOL}${process.env.VUE_APP_API_PATH}/sol`;

const urlBase = `${api}/subareas`;

export default {
    obterTodos(active) {
        active == null ? active = '' : active
        return axiosJwt.get(`${urlBase}?active=${active}`);
    },
    obterPorId(id) {
        return axiosJwt.get(`${urlBase}/${id}`);
    },
    excluir(id) {
        return axiosJwt.delete(`${urlBase}/${id}`);
    },
    inserir(subArea) {
        return axiosJwt.post(`${urlBase}`, subArea);
    },
    atualizar(id, subArea) {
        return axiosJwt.put(`${urlBase}/${id}`, subArea);
    },
    obterSubTematicaSas(id) {
        return axiosJwt.get(`${api}/sas/tematicas/${id}`);
    },
};
